import React, { useState } from 'react';
import API from '../api';

/**
 * Invite people to a pool you run — by email, or by handing the code to your
 * phone's own share sheet.
 *
 * The share button is deliberately not "send them a text". Sending SMS from the
 * server would mean a Twilio number, per-message cost, carrier A2P registration,
 * and storing everyone's phone number — and the result would be a text from a
 * number nobody recognises telling them to enter a code, which is
 * indistinguishable from a scam and gets ignored. Handing the same words to the
 * share sheet sends it from the commissioner's own number, to a person who
 * knows them, for nothing.
 */
export default function PoolInvite({ pool }) {
  const [emails, setEmails] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const flash = (ok, text) => { setMsg({ ok, text }); setTimeout(() => setMsg(null), 6000); };

  const send = async () => {
    const list = emails.split(/[\n,;\s]+/).map(e => e.trim()).filter(Boolean);
    if (!list.length) return;
    const bad = list.filter(e => !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e));
    if (bad.length) {
      // Caught here rather than by the server, which quietly skips anything
      // without an @ — a typo'd address should be fixed, not silently dropped.
      flash(false, `Doesn't look like an email: ${bad.slice(0, 3).join(', ')}`);
      return;
    }
    setBusy(true);
    try {
      const res = await API.post('/invites/send', { pool_id: pool.id, emails: list });
      flash(true, res.data.message || `Sent ${list.length}`);
      if (!res.data.failed?.length) setEmails('');
    } catch (err) {
      flash(false, err.response?.data?.error || 'Could not send');
    }
    setBusy(false);
  };

  return (
    <div style={{ marginTop: 10, width: '100%' }}>
      <div style={{ fontSize: 10, color: '#445', fontWeight: 700, letterSpacing: 1, marginBottom: 6 }}>
        INVITE BY EMAIL
      </div>
      <textarea
        value={emails}
        onChange={e => setEmails(e.target.value)}
        placeholder="one or more addresses, separated by commas"
        rows={2}
        style={{
          width: '100%', boxSizing: 'border-box', padding: '8px 10px', resize: 'vertical',
          background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: 6, color: '#fff', fontSize: 13, outline: 'none', fontFamily: 'inherit'
        }}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
        <button
          onClick={send}
          disabled={busy || !emails.trim()}
          style={{
            padding: '7px 16px', borderRadius: 6, border: '1px solid rgba(127,179,255,0.35)',
            background: 'rgba(127,179,255,0.12)', color: '#7fb3ff', fontSize: 12, fontWeight: 700,
            cursor: busy || !emails.trim() ? 'default' : 'pointer', opacity: busy || !emails.trim() ? 0.5 : 1
          }}
        >{busy ? 'Sending…' : '✉️ Send invites'}</button>
        <span style={{ fontSize: 11, color: '#445' }}>
          They arrive from noreply@rivalrypicks.com with your name on them.
        </span>
      </div>
      {msg && (
        <div style={{
          marginTop: 8, fontSize: 12, fontWeight: 600,
          color: msg.ok ? '#4caf50' : '#ff8888'
        }}>{msg.ok ? '✅ ' : '⚠️ '}{msg.text}</div>
      )}
    </div>
  );
}
